/**
 * ページングオプション(リクエスト・レスポンスの両方で使いまわしているが不都合あったら分離)
 * @property {number} pageSize - ページサイズ
 * @property {number} offset - APIにリクエストする際のオフセット
 * @property {number} nextOffset - 次のページのオフセット　←　TODO: 互換性のためにオプショナルにしてるだけなので、不要なら削除する
 * @property {number} totalResultsAvailable - 取得可能な全結果数　←　APIのリクエストには不要なのでオプショナル
 * @property {number} returnCount - 取得した結果数　←　APIのリクエストには不要なのでオプショナル
 */
export interface IPagingOptions {
  pageSize: number;
  offset: number;
  nextOffset?: number;
  totalResultsAvailable?: number;
  returnCount: number;
}

/**
 * ページングオプションの初期化
 * @param pageSize - ページサイズ
 */
export const initPagingOptions = (pageSize: number): IPagingOptions => ({
  pageSize: pageSize,
  offset: 0,
  totalResultsAvailable: 0,
  returnCount: 0,
});
